import { isEmbedVideo, getPlatform } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
import $ from 'jquery';

export default class CollectionsListTracker {
  constructor() {
    return true;
  }

  track() {
    var isEmbed = isEmbedVideo();
    var $node   = isEmbed ? $(".playlist__videos") : $("#player-list");

    if ($node.attr('data-video-id') !== undefined) {
      var properties = {
        video_id:      $node.attr('data-video-id'),
        collection_id: $node.attr('data-collection-id'),
        embed:         isEmbed,
        login:         $node.attr('data-login'),
        platform:      getPlatform(),
        page_name:     'watch'
      };
      AhoyEvent.send('COLLECTION::GET', properties);
      this.bindList();
    }
  }

  bindList() {
    var isEmbed = isEmbedVideo();
    var $node   = isEmbed ? $(".playlist__videos") : $("#player-list");
    $node.on('click', 'a[class!="video-user"]', function(event) {
      var $delegateTarget = $(event.delegateTarget);
      var $currentTarget  = $(event.currentTarget);
      var properties = {
        source_video_id: $delegateTarget.attr('data-video-id'),
        collection_id:   $delegateTarget.attr('data-collection-id'),
        video_id:        $currentTarget.attr('data-video-id'),
        embed:           isEmbed,
        login:           $delegateTarget.attr('data-login'),
        platform:        getPlatform(),
        page_name:       'watch'
      };
      AhoyEvent.send('COLLECTION::CLICK', properties);
    });
  }

}
